import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface GradientTextProps {
  children: ReactNode;
}

export default function GradientText({ children }: GradientTextProps) {
  return (
    <Box
      component="span"
      sx={(theme) => ({
        background: theme.palette.gradient.main,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      })}
    >
      {children}
    </Box>
  );
}
